import { getEntityProfileTabActiveCount } from '../Entity'
import { UserProfileTabId } from '../User'

import { getUserProfileTabAttributesHasData } from './UserProfileTab.utils'
import { UserProfileTabAttributes } from './UserProfileTabAttributes'
import { UserProfileTabBuildings } from './UserProfileTabBuildings'
import { UserProfileTabCategories } from './UserProfileTabCategories'
import { UserProfileTabContracts } from './UserProfileTabContracts'
import { UserProfileTabDocuments } from './UserProfileTabDocuments'
import { UserProfileTabEmails } from './UserProfileTabEmails'
import { UserProfileTabPosts } from './UserProfileTabPosts'
import { UserProfileTabRequests } from './UserProfileTabRequests'
import { UserProfileTabUpdates } from './UserProfileTabUpdates'

export const USER_PROFILE_TAB_ATTRIBUTES = {
  Content: UserProfileTabAttributes,
  getHasData: getUserProfileTabAttributesHasData,
  id: UserProfileTabId.Attributes,
  titleKey: 'UserProfileTabs.AttributesTabKey',
}

export const USER_PROFILE_TAB_BUILDINGS = {
  Content: UserProfileTabBuildings,
  id: UserProfileTabId.Buildings,
  permissionKey: 'can_view_buildings',
  titleKey: 'UserProfileTabs.BuildingsTabKey',
}

export const USER_PROFILE_TAB_CATEGORIES = {
  Content: UserProfileTabCategories,
  id: UserProfileTabId.Categories,
  permissionKey: 'can_view_categories',
  titleKey: 'UserProfileTabs.CategoriesTabKey',
}

export const USER_PROFILE_TAB_CONTRACTS = {
  Content: UserProfileTabContracts,
  getCount: getEntityProfileTabActiveCount,
  id: UserProfileTabId.Contracts,
  permissionKey: 'can_view_contracts',
  titleKey: 'UserProfileTabs.ContractsTabKey',
}

export const USER_PROFILE_TAB_DOCUMENTS = {
  Content: UserProfileTabDocuments,
  id: UserProfileTabId.Documents,
  permissionKey: 'can_view_files',
  titleKey: 'UserProfileTabs.DocumentsTabKey',
}

export const USER_PROFILE_TAB_EMAILS = {
  Content: UserProfileTabEmails,
  id: UserProfileTabId.Emails,
  permissionKey: 'can_view_emails',
  titleKey: 'UserProfileTabs.EmailsTabKey',
}

export const USER_PROFILE_TAB_POSTS = {
  Content: UserProfileTabPosts,
  id: UserProfileTabId.Posts,
  permissionKey: 'can_view_posts',
  titleKey: 'UserProfileTabs.PostsTabKey',
}

export const USER_PROFILE_TAB_REQUESTS = {
  Content: UserProfileTabRequests,
  id: UserProfileTabId.Requests,
  permissionKey: 'can_view_requests',
  titleKey: 'UserProfileTabs.RequestsTabKey',
}

export const USER_PROFILE_TAB_UPDATES = {
  Content: UserProfileTabUpdates,
  id: UserProfileTabId.Updates,
  permissionKey: 'can_view_updates',
  titleKey: 'UserProfileTabs.UpdatesTabKey',
}
